export const OPEN_ID_CONNECT_DIALOG_ID = "open-id-connect-flow-dialog";
export const OPEN_ID_CONNECT_RETURN_URL_KEY = "openIdConnectReturnUrl";
export const OPEN_ID_CONNECT_SHOULD_REMEMBER_USER_KEY = "openIdConnectShouldRemember";
export const OPEN_ID_CONNECT_LAST_ACTIVE_USER_KEY = "openIdConnectLastActiveUser";
export const OPEN_ID_CONNECT_CPR_KEY = "openIdConnectCPR";
export const OPEN_ID_CONNECT_CURRENT_JOURNEY_KEY = "currentJourney"; // has to match with the one in google-auth-transaction.const.ts
export const OPEN_ID_CONNECT_REGISTRATION_CPR_KEY = "openIdConnectRegistrationCprKey";
export const CACHE_STORE_OPEN_ID_CONNECT = "common.verification.open-id-connect-return-url";

export interface OpenIdConnectUrlResponse {
	endpointUri: string;
}

export const enum OpenIdConnectProviders {
	MitId = "mitid",
	Google = "google",
}

export interface OpenIdConnectShouldRememberUserData {
	shouldRememberUser: boolean;
	cpr?: string;
	expiry?: number;
}
